<div class="experience-map">
  <ng-container *transloco="let t; prefix: 'experience'">
    @if (address?.location) {
      <button
        type="button"
        class="button-content map"
        #mapContainer
        data-cy="experience-map"
        [attr.aria-label]="t('mapContainer')"
        (click)="navigateToGoogleMaps()"
      ></button>
    }
    <section class="location-info" role="region" [attr.aria-label]="t('pointsOfInterest')">
      @if (address?.full_address) {
        <section class="location" data-cy="experience-location">
          <h3 class="heading-s"
            ><strong>{{ t('location') }}</strong></h3
          >
          @if (address?.mapsUrl) {
            <a href="{{ address?.mapsUrl }}" target="_blank">
              <p class="heading-l" data-cy="experience-location-url">{{
                address?.address ? address?.address : address?.city + ', ' + address?.country
              }}</p>
            </a>
          }
          <p class="heading-l">{{ address?.city }}</p>
          <p class="heading-l">{{ address?.country }}</p>
          @if (address?.website) {
            <a href="{{ address?.website }}" target="_blank" data-cy="experience-btn-visit-website">
              <button type="button" class="ess-btn" data-cy="experience-btn-visit-website">
                {{ t('visitTheWebsite') }} <i class="icon" [innerHTML]="websiteIcon"></i>
              </button>
            </a>
          }
        </section>
      }
    </section>
  </ng-container>
</div>
